define('header_sidebar.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('header_sidebar', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/Code25/Caterparts_C25_Theme/24.0.0/', 'extensions/Code25/Caterparts_C25_Theme/24.0.0/', Handlebars);
});